export default {
  saveToken (token) {
    return localStorage.setItem('qlmn_token', token);
  },

  removeToken () {
    return localStorage.removeItem('qlmn_token');
  },

  checkIsAuthenticated: function () {
    let tokenDataStr = localStorage.getItem('qlmn_token');
    return Promise.resolve(tokenDataStr);
  },

  getToken () {
    let tokenStr = localStorage.getItem('qlmn_token');
    return tokenStr || null;
  },

  get (key) {
    return localStorage.getItem(key);
  },

  set (key, value) {
    return localStorage.setItem(key, value);
  },

  remove (key) {
    return localStorage.removeItem(key);
  }
};



// WEBPACK FOOTER //
// ./src/utils/authen.js